import React from "react";
import { extractSectionCode, cleanSectionName } from "./sectionCode";

const SectionCodeChip = ({ code, active }) => (
  <span
    className={`inline-flex items-center justify-center min-w-[2.25rem] h-7 px-1.5 rounded text-xs font-semibold ${
      active
        ? "bg-indigo-100 text-indigo-700 border border-indigo-200"
        : "bg-gray-100 text-gray-700 border border-gray-200"
    }`}
  >
    {code}
  </span>
);

const VqqSectionSidebar = ({ sections, activeSection, onSelect }) => {
  if (!sections || sections.length === 0) return null;

  return (
    <nav aria-label="Questionnaire sections" className="w-72 shrink-0">
      <div className="text-[11px] font-semibold uppercase tracking-wider text-gray-500 mb-2 px-1">
        Sections
      </div>
      <ul className="space-y-1">
        {sections.map((section) => {
          const isActive = section.section === activeSection;
          const total = section.question_count ?? 0;
          const approved = section.approved_count ?? 0;
          const code = extractSectionCode(section.section);
          const label = cleanSectionName(section.section);

          return (
            <li key={section.section}>
              <button
                type="button"
                onClick={() => onSelect(section.section)}
                className={`w-full text-left rounded-md px-2 py-2 text-sm transition flex items-center gap-2.5 ${
                  isActive
                    ? "bg-indigo-50 border border-indigo-200"
                    : "border border-transparent hover:bg-gray-50"
                }`}
                aria-current={isActive ? "true" : undefined}
              >
                <SectionCodeChip code={code} active={isActive} />
                <span
                  className={`flex-1 truncate ${
                    isActive ? "text-indigo-700 font-medium" : "text-gray-700"
                  }`}
                >
                  {label}
                </span>
                <span className="shrink-0 text-xs font-medium text-emerald-700">
                  {approved}/{total}
                </span>
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default VqqSectionSidebar;
